var map = {
	"./AD.png": 53047,
	"./AE.png": 83701,
	"./AF.png": 76578,
	"./AG.png": 99620,
	"./AI.png": 12197,
	"./AL.png": 46348,
	"./AM.png": 5937,
	"./AN.png": 95059,
	"./AO.png": 19227,
	"./AQ.png": 16541,
	"./AR.png": 57147,
	"./AS.png": 34485,
	"./AT.png": 75860,
	"./AU.png": 70265,
	"./AW.png": 81386,
	"./AX.png": 40246,
	"./AZ.png": 66833,
	"./BA.png": 15528,
	"./BB.png": 81150,
	"./BD.png": 59145,
	"./BE.png": 34914,
	"./BF.png": 24766,
	"./BG.png": 55204,
	"./BH.png": 89895,
	"./BI.png": 53521,
	"./BJ.png": 90305,
	"./BL.png": 72233,
	"./BM.png": 71758,
	"./BN.png": 71750,
	"./BO.png": 56026,
	"./BR.png": 9996,
	"./BS.png": 96425,
	"./BT.png": 22543,
	"./BW.png": 30536,
	"./BY.png": 10451,
	"./BZ.png": 12769,
	"./CA.png": 73436,
	"./CC.png": 28703,
	"./CD.png": 3445,
	"./CF.png": 46133,
	"./CG.png": 65826,
	"./CH.png": 94278,
	"./CI.png": 40931,
	"./CK.png": 68986,
	"./CL.png": 63122,
	"./CM.png": 72609,
	"./CN.png": 85271,
	"./CO.png": 26650,
	"./CR.png": 74521,
	"./CU.png": 15496,
	"./CV.png": 20479,
	"./CW.png": 45768,
	"./CX.png": 36797,
	"./CY.png": 32832,
	"./CZ.png": 50521,
	"./DE.png": 65362,
	"./DJ.png": 68056,
	"./DK.png": 10011,
	"./DM.png": 61011,
	"./DO.png": 1166,
	"./DZ.png": 71935,
	"./EC.png": 74564,
	"./EE.png": 2779,
	"./EG.png": 60127,
	"./EH.png": 85877,
	"./ER.png": 8098,
	"./ES.png": 28343,
	"./ET.png": 17485,
	"./EU.png": 49717,
	"./FI.png": 627,
	"./FJ.png": 38464,
	"./FK.png": 93481,
	"./FM.png": 9961,
	"./FO.png": 7845,
	"./FR.png": 94476,
	"./GA.png": 79488,
	"./GB.png": 74538,
	"./GD.png": 85661,
	"./GE.png": 16510,
	"./GG.png": 19289,
	"./GH.png": 60280,
	"./GI.png": 48093,
	"./GL.png": 85201,
	"./GM.png": 37243,
	"./GN.png": 96087,
	"./GQ.png": 98541,
	"./GR.png": 90004,
	"./GS.png": 87928,
	"./GT.png": 77099,
	"./GU.png": 91374,
	"./GW.png": 42433,
	"./GY.png": 80459,
	"./HK.png": 75892,
	"./HN.png": 48469,
	"./HR.png": 86199,
	"./HT.png": 44206,
	"./HU.png": 57546,
	"./IC.png": 76160,
	"./ID.png": 40355,
	"./IE.png": 36551,
	"./IL.png": 86538,
	"./IM.png": 22977,
	"./IN.png": 41790,
	"./IQ.png": 83152,
	"./IR.png": 50407,
	"./IS.png": 36679,
	"./IT.png": 64727,
	"./JE.png": 89690,
	"./JM.png": 46875,
	"./JO.png": 44800,
	"./JP.png": 39667,
	"./KE.png": 19809,
	"./KG.png": 9541,
	"./KH.png": 86688,
	"./KI.png": 48225,
	"./KM.png": 79380,
	"./KN.png": 12094,
	"./KP.png": 51015,
	"./KR.png": 84504,
	"./KW.png": 23497,
	"./KY.png": 78752,
	"./KZ.png": 8694,
	"./LA.png": 99625,
	"./LB.png": 70569,
	"./LC.png": 98053,
	"./LI.png": 98039,
	"./LK.png": 15917,
	"./LR.png": 92495,
	"./LS.png": 11728,
	"./LT.png": 52474,
	"./LU.png": 64424,
	"./LV.png": 4929,
	"./LY.png": 5824,
	"./MA.png": 43309,
	"./MC.png": 90485,
	"./MD.png": 81723,
	"./ME.png": 53817,
	"./MF.png": 80190,
	"./MG.png": 89365,
	"./MH.png": 44878,
	"./MK.png": 93693,
	"./ML.png": 40467,
	"./MM.png": 7055,
	"./MN.png": 32072,
	"./MO.png": 39719,
	"./MP.png": 99194,
	"./MQ.png": 33621,
	"./MR.png": 60146,
	"./MS.png": 45455,
	"./MT.png": 50606,
	"./MU.png": 61879,
	"./MV.png": 87404,
	"./MW.png": 67035,
	"./MX.png": 27224,
	"./MY.png": 45793,
	"./MZ.png": 99400,
	"./NA.png": 11438,
	"./NC.png": 95767,
	"./NE.png": 11077,
	"./NF.png": 7065,
	"./NG.png": 66807,
	"./NI.png": 44275,
	"./NL.png": 93113,
	"./NO.png": 52616,
	"./NP.png": 60270,
	"./NR.png": 67853,
	"./NU.png": 63955,
	"./NZ.png": 76507,
	"./OM.png": 72776,
	"./PA.png": 10728,
	"./PE.png": 73697,
	"./PF.png": 98114,
	"./PG.png": 26167,
	"./PH.png": 73162,
	"./PK.png": 6909,
	"./PL.png": 77374,
	"./PN.png": 22383,
	"./PR.png": 89447,
	"./PS.png": 51857,
	"./PT.png": 71533,
	"./PW.png": 52577,
	"./PY.png": 55754,
	"./QA.png": 85261,
	"./RO.png": 62734,
	"./RS.png": 72669,
	"./RU.png": 1233,
	"./RW.png": 16861,
	"./SA.png": 19849,
	"./SB.png": 83920,
	"./SC.png": 70910,
	"./SD.png": 60809,
	"./SE.png": 74250,
	"./SG.png": 2778,
	"./SH.png": 91253,
	"./SI.png": 26224,
	"./SK.png": 90948,
	"./SL.png": 7288,
	"./SM.png": 99544,
	"./SN.png": 59425,
	"./SO.png": 13450,
	"./SR.png": 32215,
	"./SS.png": 64530,
	"./ST.png": 73636,
	"./SV.png": 73543,
	"./SY.png": 19322,
	"./SZ.png": 26262,
	"./TC.png": 71999,
	"./TD.png": 12948,
	"./TF.png": 4093,
	"./TG.png": 2104,
	"./TH.png": 60229,
	"./TJ.png": 79846,
	"./TK.png": 6974,
	"./TL.png": 82197,
	"./TM.png": 53690,
	"./TN.png": 48148,
	"./TO.png": 54751,
	"./TR.png": 17657,
	"./TT.png": 80997,
	"./TV.png": 58796,
	"./TW.png": 1839,
	"./TZ.png": 76405,
	"./UA.png": 42106,
	"./UG.png": 69136,
	"./US.png": 2931,
	"./UY.png": 13881,
	"./UZ.png": 17789,
	"./VA.png": 4907,
	"./VC.png": 20080,
	"./VE.png": 43332,
	"./VG.png": 26769,
	"./VI.png": 58934,
	"./VN.png": 11019,
	"./VU.png": 70460,
	"./WF.png": 20648,
	"./WS.png": 98604,
	"./YE.png": 70723,
	"./YT.png": 17127,
	"./ZA.png": 65111,
	"./ZM.png": 91795,
	"./ZW.png": 81216,
	"./_abkhazia.png": 98852,
	"./_basque-country.png": 32767,
	"./_british-antarctic-territory.png": 91707,
	"./_commonwealth.png": 50679,
	"./_england.png": 9170,
	"./_gosquared.png": 29392,
	"./_kosovo.png": 40005,
	"./_mars.png": 15577,
	"./_nagorno-karabakh.png": 23086,
	"./_nato.png": 34165,
	"./_northern-cyprus.png": 37216,
	"./_olympics.png": 74675,
	"./_red-cross.png": 78504,
	"./_scotland.png": 58445,
	"./_somaliland.png": 92659,
	"./_south-ossetia.png": 46573,
	"./_united-nations.png": 64449,
	"./_unknown.png": 85785,
	"./_wales.png": 13934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87838;